import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button
} from '@mui/material';

const BulkDeleteConfirmDialog = ({ 
  open, 
  onClose, 
  onConfirm, 
  selectedCount 
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Confirmar eliminación
      </DialogTitle>
      
      <DialogContent>
        <DialogContentText>
          ¿Eliminar las <strong>{selectedCount}</strong> lección{selectedCount !== 1 ? 'es' : ''} de usuario seleccionada{selectedCount !== 1 ? 's' : ''}? 
          Esta acción no se puede deshacer.
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancelar
        </Button>
        <Button 
          onClick={handleConfirm} 
          variant="contained" 
          color="error"
        >
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BulkDeleteConfirmDialog;